import { Masse, MasseArr } from "./Masse";
import { libBerechneDatumVolljaehrigAb } from "../lib/libHelpers";
import { Sendungszeile } from "./Sendungszeile";
import { WebserviceEnvironment } from "./environment";
import { Preis } from "./Preis";

//Konstanten
export const REGEX_PLZ = new RegExp("^\\d{5}$");
export const REGEX_USTID = new RegExp("^DE\\d{9}$");
export const REGEX_EMAIL = new RegExp("^(?:[a-z0-9!#$%&'*+\\/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+\\/=?^_`{|}~-]+)*|\"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])$")

export type Adresse = {
    firma: string | null;
    name: string | null;
    ustid: string | null;
    str: string | null;
    plz: string | null;
    ort: string | null;
    tel: string | null;
    email: string | null;
    gebDat: string | null;
}

export const adresseDefaults : Adresse = {
    firma: null,
    name: null,
    ustid: null,
    str: null,
    plz: null,
    ort: null,
    tel: null,
    email: null,
    gebDat: null,
}

export const pruefeAdresse = (auftrag: Auftrag, adrArt: AuftragAdrKeys) : string | null => {
    let fehler : string | null = null
    const adresse = auftrag[adrArt];

    if(adrArt == "fz" && ((auftrag.sendung?.warenwert ?? null) == null && adresse.firma == null || REGEX_USTID.test(adresse.ustid ?? "") && adresse.firma == null)) {
        fehler = "Bitte einen gültigen Firmennamen eingeben";
    } else if(adresse.name == null) {
        fehler = "Bitte einen gültigen Vor- und Nachnamen eingeben";
    } else if( adrArt == "fz" && ((!REGEX_USTID.test(adresse.ustid ?? "") && adresse.ustid != null) || adresse.firma != null && adresse.ustid == null)) {
        fehler = "Bitte gültige Ust-ID eingeben";
    } else if(adresse.str == null) {
        fehler = "Bitte gültige Straße- und HausNr. eingeben";
    } else if(!REGEX_PLZ.test(adresse.plz ?? "")) {
        fehler = "Bitte gültige PLZ eingeben";
    } else if(adresse.ort == null) {
        fehler = "Bitte gültigen Ort eingeben";
    } else if(adresse.tel == null) {
        fehler = "Bitte gültige Tel-Nr. eingeben";
    } else if(!REGEX_EMAIL.test(adresse.email ?? "")) {
        fehler = "Bitte gültige E-Mail-Adresse eingeben";
    } else if(adrArt == "fz" && (adresse.gebDat == null || new Date(adresse.gebDat) > libBerechneDatumVolljaehrigAb())) {
        fehler = "Bitte ein gültiges Geburtsdatum eingeben!";
    }

    return fehler;
}

export type AuftragAdr = {
    lad: Adresse;
    elad: Adresse;
    fz: Adresse;
}

export interface Auftrag extends AuftragAdr {
//    warenwert: string | null;
    istFahrtuechtig : boolean;
    letzterPreis : Preis | null;
    sendung : Sendungszeile | null;
    referenz : string | null;
}

export type AuftragAdrKeys = keyof AuftragAdr;

export const auftragDefaults : Auftrag = {
    istFahrtuechtig : false,
//    warenwert: null,
    lad: adresseDefaults,
    elad: adresseDefaults,
    fz: adresseDefaults,
    letzterPreis : null,  //Letzter berechneter Preis. Wichtig für die Überprüfung. Wenn übergebener Preis nicht mit dem Preis übereinstimmt,
                            //der beim Auftragsspeichern berechnet wird, dann Fehler ausgeben, da dem Kunden ja dann ein falscher Preis angezeigt wurde
    sendung : null,
    referenz : null,
}

export const istAdresseGleichFrachtzahler = (fz : Adresse, adr : Adresse) => JSON.stringify(fz) == JSON.stringify(adr)

export type AuftragSpeichernRueckgabe = {
    fehler : string | null;
    preis : Preis | null;
    referenz : string | null;
}

export const auftragAbsendenHttp = async (auftrag : Auftrag, webserviceEnvironment : WebserviceEnvironment) => {
      //console.log(webserviceEnvironment);
      const data = await (await fetch(webserviceEnvironment.AuftragSpeichern.url, {method: 'POST', body: JSON.stringify(auftrag)})).json();
      const res : AuftragSpeichernRueckgabe = await webserviceEnvironment.AuftragSpeichern.fnData(data);
      //setAuftrag({...auftrag, letzterPreis: res.preis})
  
      return res;
        //return false;
}

export const auftragAbsendenCoponent = async (auftrag: Auftrag, webserviceEnvironment : WebserviceEnvironment) : Promise<Auftrag> => {
    const rueckgabe = await auftragAbsendenHttp(auftrag, webserviceEnvironment);
    let ret: string | null = null;
    if (rueckgabe.fehler != null) {
        throw rueckgabe.fehler;
    } else if(rueckgabe.referenz == null){
        throw "Fehler bei der Rückgabe der AuftragsNr";
    } else {
      return{...auftrag, referenz: rueckgabe.referenz, letzterPreis: rueckgabe.preis};
    }
  }